@if (routerLink()) {
    <a
        [routerLink]="routerLink()"
        class="DsListItem-link"
        [attr.tabindex]="parent.tabbable() && !disabledInput() ? 0 : -1"
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
} @else if (href()) {
    <a
        [href]="href()"
        [target]="target()"
        [attr.rel]="target() === '_blank' ? 'noopener noreferrer' : null"
        class="DsListItem-link"
        [attr.tabindex]="parent.tabbable() && !disabledInput() ? 0 : -1"
    >
        <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
} @else {
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
}

<ng-template #itemContent>
    <ng-content select="[ds-list-item-prefix],[ds-list-option-prefix]"></ng-content>

    @if (hasTitleOrDescription()) {
        <div class="DsListItem-title">
            <ng-content select="[ds-list-item-title],[ds-list-option-title]"></ng-content>
            <ng-content select="[ds-list-item-description],[ds-list-option-description]"></ng-content>
        </div>
    } @else {
        <ng-content></ng-content>
    }

    <ng-content select="[ds-list-item-suffix],[ds-list-option-suffix]"></ng-content>
</ng-template>
